import { fireEvent } from '../../../../index'
import { ADD_TO_CART } from '../../../../topics'
import { getCoffeeSubAddToCartPayload } from './utils/payloads'

export const coffeeSubsUKGetStartedEvent = () => {
  const coffeeSubEventPayload = getCoffeeSubAddToCartPayload()
  fireEvent(ADD_TO_CART, coffeeSubEventPayload)
}
